<div class="bg_login d-flex">
    <div class="w-50 h-100 login_div">
        <div class="login_form">
            <div class="text-center mb-4">
                <img src="assets/images/logo/resy_logo.png">
            </div>
            <h3 class="sign_in ">{{'INFO.SIGN_IN' | translate |uppercase}}
                <!-- <app-change-language [ShowFullName]="false"></app-change-language> -->
             </h3>

            <div class="login_field">
                <label class="lbl_resy_field">{{'LOGIN.EMAIL'|translate}}
                    <i *ngIf="errorModel!=null && errorModel['Username']!=null"
                        class="pi pi-exclamation-circle float-end me-1 error_color pt-1"
                        pTooltip="{{errorModel['Username']|translate}}" tooltipPosition="top"></i>
                </label>
                <input type="text" class="input_field mb-4" [(ngModel)]="loginModel.username" (keydown.enter)="login(loginModel)">
                <label class="lbl_resy_field">{{'LOGIN.PASSWORD'|translate}}
                    <i *ngIf="errorModel!=null && errorModel['Password']!=null"
                    class="pi pi-exclamation-circle float-end me-1 error_color pt-1"
                    pTooltip="{{errorModel['Password']|translate}}" tooltipPosition="top"></i>
                </label>
                <input type="password" class="input_field" [(ngModel)]="loginModel.password" (keydown.enter)="login(loginModel)">
                <div class="page-links">
                  <a type="button" routerLink="/forgot-password" class="right signup_link">{{'INFO.FORGOT_PASSWORD'|translate}}?</a>
                </div>
                <button class="btn_login" (click)="login(loginModel)">{{'INFO.SIGN_IN'|translate}}</button>
                <!-- <p class="p_sign_up">{{'LOGIN.GO_TO_REGISTER' | translate}} <a type="button" routerLink="/signup" class="signup_link">{{'INFO.SIGN_UP' | translate }}</a></p> -->
            </div>
        </div>
    </div>
</div>
